import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  products: []
};
export const productSlice = createSlice({
  name: 'productSlice',
  initialState: initialState,
  reducers: {
    updateProductList(state, action) {
      state.products = action.payload;
    }
  }
});

export const productActions = productSlice.actions;
